<script>
import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
gsap.registerPlugin(SplitText)

export default {
  name: "ControlsExplained",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    isMap: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    gsap.set(this.$refs.controlsexplained.children,{autoAlpha:0, onComplete: () => { this.initAnimation()}})

  },
  data() {
    return {
      selectedImage: null
    }
  },
  methods: {
    closeOverlay() {
      this.$emit('closeOverlay');
    },
    initAnimation() {
      gsap.to(this.$refs.controlsexplained.children, {
        y: "10%",
        autoAlpha:1,
        stagger: 0.3, // 0.1 seconds between when each ".box" element starts animating
      });
    }
  }
}
</script>

<template>
  <div ref="smallPopup" id="sidebarpopup" class="popup overlay smallerpopup" data-model="">
    <div ref="popup_wrapper__smaller" class="popup_wrapper popup_wrapper__smaller">
               <span @click="closeOverlay" class="popup_closepopup closeoverlay">
<svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
</span>
      <div class="popup_content popup_content_right">
        <div ref="controlsexplained" class="controlsexplained" style="display: flex; align-items: stretch; flex-direction: column; gap:80px;">
          <figure>
            <img src="@/assets/img/mouselefthold.png"/>
            <figcaption>
              <span class="yellow">{{$t('ControlsExplained.controlElement1_part1')}} </span>{{$t('ControlsExplained.controlElement1_part2')}}<br/> {{$t('ControlsExplained.controlElement1_part3')}}
            </figcaption>
          </figure>
          <figure>
            <img src="@/assets/img/mousewheel.png"/>
            <figcaption>
              <span class="yellow">{{$t('ControlsExplained.controlElement2_part1')}} </span>{{$t('ControlsExplained.controlElement2_part2')}}<br/> {{$t('ControlsExplained.controlElement2_part3')}}
            </figcaption>
          </figure>
          <figure>
            <img src="@/assets/img/mouseleftclick.png"/>
            <figcaption>
              <span class="yellow">{{$t('ControlsExplained.controlElement3_part1')}} </span>{{$t('ControlsExplained.controlElement3_part2')}}<br/> {{$t('ControlsExplained.controlElement3_part3')}}
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>

$yellow: #FDBE1F;
.closeoverlay {
  padding: 10px;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  position: absolute;
  right: 35px;
  top: 35px;
  border-radius: 10px;
  transition: 0.3s;
  box-sizing: border-box;
  z-index: 2;


  svg {
    width: 80%;
    height: auto;
  }

  &:hover {
    cursor: pointer;
    color: $yellow;
  }


  @media screen and (max-width: 768px) {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 35px;
    top: 26px;
  }
  @media screen and (max-width: 640px) {
    right: 15px;
  }
}

.popup_wrapper__smaller {
  padding:125px;
  @media screen and (max-width: 768px) {
   padding:75px 25px;
  }
  @media screen and (max-width: 640px) {
   padding:50px 25px !important;
  }
}

#sidebarpopup:has(.controlsexplained) {
  background: rgba(0, 0, 0, 0.5) !important;
  color: #fff;

  figure {
    display: flex;
    gap: 20px;
    align-items: center;

    img {
      width: 50px;
      height: auto;
      flex:0 0 auto;
    }
  }

  .yellow {
    color: #FDBE1F;
  }

  .closeoverlay {
    background: none;
    transition:0.3s;
    &:hover {
      line {
        stroke:#FDBE1F
      }
    }
  }
}

.controlsexplained {
  @media screen and (max-width:640px) {
    gap:30px !important;
  }
  @media screen and (max-width:560px) {
br{
  display:none;
}
  }
}


</style>
